import React from 'react';
import PropTypes from 'prop-types';
import {observe} from 'mobx';
import {inject} from 'mobx-react';
import autobind from 'autobind-decorator';

function getStyle(el, styleProp) {
  let y;
  if (el.currentStyle) {
    y = el.currentStyle[styleProp];
  } else if (window.getComputedStyle) {
    y = document.defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
  }
  return y;
}

@inject('store')
class TextArea extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    store: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.clone = document.createElement('div');
    this.clone.style.font = getStyle(this.wrappedInstance, 'font');
    this.clone.style.whiteSpace = 'pre-wrap';
    this.clone.style.wordWrap = 'break-word';
    this.clone.style.wordBreak = 'break-word';

    this.componentWillUnmount = observe(this.props.store.screen, 'width', () => {
      // listen for resize
      this.clone.style.width = getStyle(this.wrappedInstance, 'width');
      this.clone.style.padding = getStyle(this.wrappedInstance, 'padding');

      this.updateHeight();
    }, true);
  }

  get validity() {
    return this.wrappedInstance.validity;
  }

  updateHeight() {
    if (this.wrappedInstance) {
      this.clone.innerText = this.wrappedInstance.value + '\n';
      document.body.appendChild(this.clone);
      this.wrappedInstance.style.height = `${this.clone.clientHeight + 5}px`;
      document.body.removeChild(this.clone);
    }
  }

  @autobind onChange(event) {
    this.updateHeight();
    if (this.props.onChange) {
      this.props.onChange(event);
    }
  }

  @autobind inputRef(input) {
    this.wrappedInstance = input;
  }

  render() {
    const {store, ...rest} = this.props;
    return <textarea {...rest} onChange={this.onChange} ref={this.inputRef} />;
  }
}

export default TextArea;



// WEBPACK FOOTER //
// ./spa/Components/Form/Textarea.jsx